/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic haiku follow 5-7-5, but many modern English haiku are more flexible. This checker targets the traditional pattern as a guide.`)
};

const es_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los haikus clásicos siguen el patrón 5-7-5, pero muchos haikus modernos en inglés son más flexibles. Este verificador toma el patrón tradicional como guía orientativa.`)
};

const de_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassische Haikus folgen dem Muster 5-7-5, aber viele moderne englische Haikus sind flexibler. Dieser Prüfer orientiert sich am traditionellen Muster als Richtwert.`)
};

const nl_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassieke haiku's volgen 5-7-5, maar veel moderne Engelse haiku's zijn flexibeler. Deze controle hanteert het traditionele patroon als richtlijn.`)
};

const fr_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les haïkus classiques suivent le schéma 5-7-5, mais de nombreux haïkus anglais modernes sont plus flexibles. Ce vérificateur prend le schéma traditionnel comme simple repère.`)
};

const it_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli haiku classici seguono lo schema 5-7-5, ma molti haiku moderni in inglese sono più flessibili. Questo strumento di verifica prende come riferimento lo schema tradizionale come guida.`)
};

const pt_br2_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os haikus clássicos seguem o padrão 5-7-5, mas muitos haikus ingleses modernos são mais flexíveis. Este verificador usa o padrão tradicional como referência.`)
};

const pt_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os haiku clássicos seguem o padrão 5-7-5, mas muitos haiku ingleses modernos são mais flexíveis. Este verificador utiliza o padrão tradicional como referência.`)
};

const ja_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伝統的な俳句は5-7-5に従いますが、現代の英語俳句の多くはより柔軟です。このチェッカーは、あくまで目安として伝統的なパターンを基準にしています。`)
};

const zh_syl_haiku_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`古典俳句遵循5-7-5格式，但许多现代英语俳句更为灵活。本检测器以传统格式作为参考标准。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq2_a", locale)
	if (locale === "en") return en_syl_haiku_faq2_a(inputs)
	if (locale === "es") return es_syl_haiku_faq2_a(inputs)
	if (locale === "de") return de_syl_haiku_faq2_a(inputs)
	if (locale === "nl") return nl_syl_haiku_faq2_a(inputs)
	if (locale === "fr") return fr_syl_haiku_faq2_a(inputs)
	if (locale === "it") return it_syl_haiku_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq2_a(inputs)
	if (locale === "pt") return pt_syl_haiku_faq2_a(inputs)
	if (locale === "ja") return ja_syl_haiku_faq2_a(inputs)
	return zh_syl_haiku_faq2_a(inputs)
};